import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'doctorOther'
})
export class DoctorOtherPipe implements PipeTransform {
  transform(items: any[], searchText: string) {
    return items ? items.filter(item =>
      item.subSpecialityName &&
      item.subSpecialityName.search(new RegExp(searchText, 'i')) > -1
    ) : [];
  }
}
